import axios from 'axios';
import { ISeasonUpsert } from '../../../@types/model/masterData/season/seasonUpsert';
import { ISeason } from '../../../@types/model/masterData/season/season';
import { UpsertTypeEnum } from '../../../@types/enum/upsertType';

export default class SeasonHttpService {
    public static getList = async (lastSyncedTimeUnix : number, signal ?: AbortSignal) : Promise<Array<ISeason>> => {
        const result = await axios.get(`${API_URL}/v1/MasterData/Season/GetList`, {
            params: {
                lastSyncedTimeUnix
            },
            signal
        });

        return result.data;
    }

    public static upsert = async (upsert : ISeasonUpsert, type : UpsertTypeEnum) : Promise<ISeason> => {
        const result = await axios.post(`${API_URL}/v1/MasterData/Season/${type}`, upsert);

        return result.data;
    }

    public static delete = async (id : number) : Promise<void> => {
        return await axios.delete(`${API_URL}/v1/MasterData/Season/Delete`, {
            params: { id },
        });
    }
}